import React, { Component } from "react"
import MaterialModal from "../../MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import { Icon } from "antd"
import { TASK_TYPE } from "./stores/TaskModel"

export default class DeleteModal extends Component {
  render () {
    const { onCancel, task = { children: [] }, ...rest } = this.props
    let title, subTitle, description, warning
    if (task.type === TASK_TYPE.file) {
      title = "数据上传取消"
      subTitle = "家系：" + task.groupInfo.name
      description = task.name
      warning = "您确定要取消上传家系中的本条数据吗？"
    } else {
      title = "家系上传取消"
      subTitle = task.name
      warning = `您确定要取消上传本家系中所包含的${task.children.length}条数据吗？`
    }

    return (
      <MaterialModal
        width={450}
        title={title}
        className="upload-delete-modal"
        buttonType="danger"
        buttonText="删除"
        {...rest}>
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onCancel}
        />
        <div className="sub-title">{subTitle}</div>
        {description && <div className="description">{description}</div>}
        <div className="warning">
          <Icon type="exclamation-circle-o" />
          {warning}
        </div>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/DeleteModal.js